<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Breadcrumbs main="Onsite Renewables" title="default" />

  <div class="container-fluid p-0">
    <div class="row widget-grid">
      <div class="px-2">
      <FilterS1
        :stateProp="stateList"
        :periodNameProp="`Current MP`"
        @filterHandle="filterHandle"
       />
      </div>

      <el-row class="m-0 width-100-p mt-3">
        <!-- Abatement -->

        <!-- chart two -->
        <el-col
          class="d-flex align-item-center px-2"
          :span="$vuetify.display.width >= 1500 ? 16 : 24"
        >
          <div
            class="row m-0 bg-me-primary border-color-light width-100-p rounded-4"
          >
            <el-col :span="24">
              <h5 class="text-white mt-3 ml-1">Renewable Energy Analytics</h5>
            </el-col>

            <el-col
              :span="24"
              v-loading="loadingBarChart"
              :element-loading-spinner="svg"
              element-loading-svg-view-box="-10, -10, 50, 50"
              element-loading-background="rgba(122, 122, 122, 0.8)"
            >
              <div id="chart">
                <apexchart
                  :key="barChartKey"
                  ref="chart"
                  type="bar"
                  height="350"
                  :options="chartOptionsTwo"
                  :series="seriesTwo"
                ></apexchart>
              </div>


            </el-col>

              <el-col
                :span="12"
                class="d-flex align-items-center justify-content-start"
                v-if="showPaginationButton"
              >
                <div class="pagination" >
                  <el-button class="height-40 border-color-light rounded-3 width-100-p mr-1" @click="prevPage" :disabled="currentPage === 0">Previous</el-button>
                  <el-button class="height-40 border-color-light rounded-3 width-100-p mr-1" @click="nextPage" :disabled="(currentPage + 1) * pageSize >= largeDataset.length">Next Page</el-button>
                </div>
              </el-col>
              <el-col :span="12" class="d-flex align-items-center justify-content-end mt-3" v-if="showPaginationButton">
                <span class="text-white">
                  {{ (currentPage) * pageSize + 1 }}-{{
                    ((currentPage ) * pageSize + (pageSize)) > totalDataPoints ? totalDataPoints : (currentPage ) * pageSize + (pageSize)
                  }}
                  of {{ totalDataPoints }}
              </span>
              </el-col>
          </div>
        </el-col>

        <!-- Two cards -->
        <el-col
          class="d-flex align-item-center"
          :span="$vuetify.display.width >= 1500 ? 8 : 24"
          :class="$vuetify.display.width < 1500 ? 'mt-2' : ''"
        >
          <div class="row m-0 width-100-p">
            <el-col
              :class="$vuetify.display.width >= 1500 ? 'd-flex align-item-center px-10 py-0 mb-10' : $vuetify.display.width > 750 ? 'd-flex align-item-center px-10 py-0 mt-20' : 'd-flex align-item-center px-10 py-0 mt-20'"
              :span="
                $vuetify.display.width >= 1500 || $vuetify.display.width < 750
                  ? 24
                  : 12
              "
            >
              <div
                class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
              >
                <el-col :span="17" class="px-3 y-center">
                  <div>
                    <div class="width-100-p p-2">
                      <p class="font-25-b text-white mb-0">
                        {{
                          sessionCardData == null || sessionCardData.total_usage == null
                            ? 0
                            : sessionCardData.total_usage.toLocaleString()
                        }}
                      </p>
                    </div>
                    <p class="font-16 p-2 mt-2 text-white mb-0">
                      Total Solar to EV (MWh)
                    </p>
                  </div>
                </el-col>
                <el-col :span="7" class="pl-0 x-y-center">
                  <el-image
                    style="width: 80px; height: 80px"
                    :src="
                      require('@/assets/images/dashboard/home/FuelAvoided.png')
                    "
                    fit="cover"
                  />
                </el-col>
              </div>
            </el-col>
            <el-col
              :class="$vuetify.display.width >= 1500 ? 'd-flex align-item-center px-10 py-0 mt-10' : $vuetify.display.width > 750 ? 'd-flex align-item-center px-10 py-0 mt-20' : 'd-flex align-item-center px-10 py-0 mt-20'"
              :span="
                $vuetify.display.width >= 1500 || $vuetify.display.width < 750
                  ? 24
                  : 12
              "
            >
              <div
                class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
              >
                <el-col :span="17" class="px-3 y-center">
                  <div>
                    <div class="width-100-p p-2">
                      <p class="font-25-b text-white mb-0">
                        {{
                          sessionCardData == null || sessionCardData.total_count == null
                            ? 0
                            : sessionCardData.total_count.toLocaleString()
                        }}
                      </p>
                    </div>
                    <p class="font-16 p-2 mt-2 text-white mb-0">
                      Total Battery to EV (MWh)
                    </p>
                  </div>
                </el-col>
                <el-col :span="7" class="pl-0 x-y-center">
                  <el-image
                    style="width: 80px; height: 80px"
                    :src="
                      require('@/assets/images/dashboard/home/FuelAvoided.png')
                    "
                    fit="cover"
                  />
                </el-col>
              </div>
            </el-col>
          </div>
        </el-col>


      </el-row>
      <el-row class="m-0 width-100-p mt-3">
        <el-col class="d-flex align-item-center px-2" :span="24">
          <div class="row m-0 width-100-p">
            <div
              class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
            >
              <energyTable
                :filterProp="filter"
                @changeTab="changeTab"
                @sessionDataToParent="sessionDataToParent"
                />
            </div>
          </div>
        </el-col>
      </el-row>


    </div>

  </div>
</template>

<script>
// import Filter from "@/pages/dashboard/common/filter.vue";
import FilterS1 from "../../dashboard/common/filter-s1.vue";
import { sessionChartTwo } from "./config.js";
import UserService from "@/services/user.service.js";
import energyTable from "./energyTable.vue";

export default {
  components: {
    FilterS1,
    // Filter,
    energyTable,
  },
  data() {
    return {
      selectedPeriod: "All",
      // series: sessionChart.series,
      // chartOptions: sessionChart.chartOptions,

      seriesTwo: sessionChartTwo.series,
      chartOptionsTwo: sessionChartTwo.chartOptions,
      sumTotalUsage: 0,

      sessionCardData: {
        total_count: 0,
        total_usage: 0,
      }, // total number of sessions

      states: [],
      filter: {
        country: "",
        elec_region: "",
        startDate: null,
        endDate: null,
      },
      SessionData: [],
      pendingSessionData: [],

      childSessionData: [],
      childPendingSessionData: [],

      loading: false,
      loadingChart: false,

      firstChartKey: 0,


      loadingBarChart: false,

      selectedGroupBy: "",
      OthersCount: 0,
      totalCount: 0,
      barChartKey: 0,
      groupBy: {
        1: "All",
        2: "By Region",
        3: "By Charger",
        4: "By site",
        5: "By Error",
      },

      // pagination for chart two
      largeDataset: {
        solar: [],
        battery: []
      },
      categoryLabels: [],
      totalDataPoints: 0,
      pageSize: 6, // chart page size
      currentPage: 0,
      paginatedChartOptions: {},
      paginatedSeries: [],
      showPaginationButton: false,

    };
  },
  watch: {
    "childSessionData": function (val) {
      // receive data from child
      // update card data
        this.sessionCardData.total_count = val.totalCount;
        this.sessionCardData.total_usage = val.totalUsage;
        this.selectedGroupBy = val.selectedGroupBy;
    },


    // pagination for chart two
    paginatedData: {
      handler: "handlePaginatedData",
      immediate: true,
    },

    paginatedLabels: {
      handler: "handlePaginatedLabels",
      immediate: true,
    },
  },
  computed: {
    stateList() {
      return this.states;
    },

    // pagination for chart two
    paginatedData() {
      if (!this.largeDataset || !this.largeDataset.solar || !this.largeDataset.battery) {
        return {
          solar: [],
          battery: []
        };
      }

      let start = this.currentPage * this.pageSize;
      let end = start + this.pageSize;

      return {
        solar: this.largeDataset.solar.slice(start, end),
        battery: this.largeDataset.battery.slice(start, end)
      };
    },

    paginatedLabels() {
      let start = this.currentPage * this.pageSize;
      let end = start + this.pageSize;
      return this.categoryLabels.slice(start, end);
    },

  },

  async mounted() {
    // console.log(this.$store.state.auth.user);
    // await this.fetchData();

    // pagination for chart two
    for (let i = 1; i <= this.totalDataPoints; i++) {
      this.categoryLabels.push(`Category ${i}`);
      this.largeDataset.series.push(
        {
        solar: Math.floor(Math.random() * 100) + 1,
        battery: Math.floor(Math.random() * 100) + 1,
      });
    }
  },
  methods: {
    updatefirstChartKey() {
      this.firstChartKey += 1;
    },

    // pagination for chart two
    // updata chart labels with paginated labels
    handlePaginatedLabels() {
      this.barChartKey += 1;
      this.chartOptionsTwo.xaxis.categories = this.paginatedLabels;
    },

    // update chart series data with paginated data
    handlePaginatedData() {
      if (!this.paginatedData) {
        this.seriesTwo = [
          {
            name: 'Solar to EV (MWh)',
            type: "column",
            data: [],
            color: "#78BE20",
            fillColors: ["#78BE20"],
          },
          {
            name: 'Battery to EV (MWh)',
            type: "column",
            data: [],
            color: "#DDF0AC",
            fillColors: ["#DDF0AC"],
          }
        ];
        return;
      }

      this.seriesTwo = [
        {
          name: 'Solar to EV (MWh)',
          type: "column",
          data: this.paginatedData.solar || [],
          color: "#78BE20",
          fillColors: ["#78BE20"],
        },
        {
          name: 'Battery to EV (MWh)',
          type: "column",
          data: this.paginatedData.battery || [],
          color: "#DDF0AC",
          fillColors: ["#DDF0AC"],
        }
      ];
      this.loadingBarChart = false;
    },

    // pagination for chart two change page button
    nextPage() {
      if ((this.currentPage + 1) * this.pageSize < this.categoryLabels.length) this.currentPage++;
    },

    prevPage() {
      if (this.currentPage > 0) this.currentPage--;
    },




  /**
   * Fetches session data from the server based on the current filter settings.
   * Endpoint: api/dashboard-session-data
   *
   */
    async fetchData() {
      // update filter by location dropdown list
      // console.log("fetchData", this.states);

      if (this.states.length == 0) {
        let body = null;
          body = {
            start_date: this.filter.startDate,
            end_date: this.filter.endDate,
            customer_id: this.filter.customer_id,
            charger_name: this.filter.charger_name,
            country: this.filter.country || "",
            elec_region: this.filter.elec_region || "",
          };
          await UserService.DashboardSessionsData(body)
            .then(
              (response) => {
                // console.log(response);
                this.states = (response.data.data.session_by_state || []).map(
                  (session) => session.elec_region || session.state
                );
              },
              (error) => {
                console.log(error.message);
              }
            )
            .catch((error) => {
              console.log(error.message);
            })
            .finally(() => (this.loading = false));
      }

      let body = {
        start_time: this.filter.startDate,
        end_time: this.filter.endDate,
        command: "chart"
      };
      if (this.filter.customer_id) {
        body.customer_id = this.filter.customer_id;
      }
      if (this.filter.elec_region) {
        body.elec_region = this.filter.elec_region;
      }
      if (this.filter.country) {
        body.country = this.filter.country;
      }

      await UserService.renewableEnergyAnalytics(body)
        .then(
          (response) => {
            console.log("get response for chart");

            if (!response.data.data.grouped_chart_data || Object.values(response.data.data.grouped_chart_data).length == 0) {
              this.loading = false;
              this.largeDataset = {};
              console.log("no chart data in response");
              return;
            }

            let results = response.data.data.grouped_chart_data;
            let group_by_name = response.data.data.group_by;

            let processed_results = this.processChartData(results);

            this.loadBarChartData(processed_results, group_by_name);
            // this.fillForm();
          },
          (error) => {
            this.loading = false;

            console.log(error.message);
            this.largeDataset = {};
            // if (error.response.status == 401) {
            //   this.$router.push({
            //     path: "/",
            //   });
            // }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error.message);
          this.largeDataset = {};
          // if (error.response.status == 401) {
          //   this.$router.push({
          //     path: "/",
          //   });
          // }
        })
        .finally(() => (this.loading = false));
    },

    processChartData(results) {
      return Object.values(results).map(value => {
        return Object.entries(value).reduce((row, [key, val]) => {
          row[key] = val;
          return row;
        }, {});
      });
    },

    filterHandle(event) {
      // console.log("Charger : ", event);
      this.filter = event;
      this.fetchData();

      // console.log("Filter : ", this.filter);

    },

    // receive data from child component | used in sessionTable | update card data when tab is changed
    changeTab(event) {
      // this.SessionData = event.sessionDataList;

      this.sessionCardData.total_count = event.totalCount;
      this.sessionCardData.total_usage = event.totalUsage;

    },

    // receive data from child component | used in sessionBarCharts
    sessionDataToParent(event) {
      this.childSessionData = event;
      // console.log("Session Data from child : ", this.childSessionData);
    },

    // load group by data to chart two
    loadBarChartData(val, selectedGroupBy) {
      // console.log("loadBarChartData", val);

      console.log("selectedGroupBy : ", selectedGroupBy);
      if (!val || !Array.isArray(val)) {
        console.warn('Invalid data received in loadBarChartData');

        this.loadingBarChart = false;
        return;
      }


      this.loadingBarChart = true;

      // sort data by count_session
      // const data = val.sort((a, b) => b.count_battery_to_ev - a.count_battery_to_ev);
      const data = val;
      this.currentPage = 0; // reset pagination
      this.barChartKey += 1; // reset chart

      let solarData = [];
      let batteryData = [];
      let labels = [];

      // pagination for chart two start
      this.totalDataPoints = data.length;
      if(this.totalDataPoints > this.pageSize) {
        this.showPaginationButton = true;
      } else {
        this.showPaginationButton = false;
      }

      data.forEach((value) => {
        solarData.push(value.divided_sum_solar_to_ev.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) || 0);
        batteryData.push(value.divided_sum_battery_to_ev.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) || 0);
        labels.push(value.time);
      });

      // console.log("solarData : ", solarData);
      // console.log("batteryData : ", batteryData);
      // console.log("labels : ", labels);

      // Update the chart data structure
      this.largeDataset = {
        solar: solarData,
        battery: batteryData
      };
      this.categoryLabels = labels;

      // Update the chart series directly
      this.seriesTwo = [
        {
          name: 'Solar to EV (MWh)',
          type: "column",
          data: solarData.slice(0, this.pageSize),
          color: "#78BE20",
          fillColors: ["#78BE20"],
        },
        {
          name: 'Battery to EV (MWh)',
          type: "column",
          data: batteryData.slice(0, this.pageSize),
          color: "#DDF0AC",
          fillColors: ["#DDF0AC"],
        }
      ];

      // Update chart options
      this.chartOptionsTwo.xaxis.categories = labels.slice(0, this.pageSize);
      this.loadingBarChart = false;
    },
  },
};
</script>

<style scoped>

.pagination {
  margin-top: 10px;
  margin-bottom: 15px;
}
.pagination > .el-button {
  margin: 5px;
  padding: 10px;
  cursor: pointer;
}

</style>
